module.exports = __webpack_public_path__ + "img/_blog4.140a6be1.jpg";